import UserFriendStructure from "../Constants/UserProfileFriendStructure"; // Adjust path

export const fetchUserFriendMockData = async (userId) => {
  try {
    const response = await fetch(
      `/api/mock/UserProfile/UserProfileFriendsMockdata-${userId.toLowerCase()}.json`
    );

    if (!response.ok) {
      throw new Error(`User data file not found`);
    }

    const data = await response.json();

    const formattedData = {
      ...UserFriendStructure,

      userId: data.userId || "",
      name: {
        first: data.name?.first || "",
        middle: data.name?.middle || "",
        last: data.name?.last || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      dateOfBirth: data.dateOfBirth || "", // ISO format string
      location: data.location || "",

      friends: Array.isArray(data.friends)
        ? data.friends.map((friend) => ({
            userName: friend.userName || "",
            userId: friend.userId || "",
            imageUrl: friend.imageUrl || "",
            location: friend.location || "",
            createdOn: friend.createdOn || "",
            pastAbuse: friend.pastAbuse ?? false,
          }))
        : [],
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch user friend mock data:", error.message);
    return null;
  }
};
